module.exports = __webpack_public_path__ + "img/880bff52c6250526fd64e7a678eae99b.png";